<mat-card>
    <div class="layout-padding-bottom__1rem">
        <span class="settings-heading">Delete Loans</span>
    </div>
    <div class="layout-padding-bottom__1rem row-layout-track">
        <div class="delete-loan-search-area">
            <search-dialog
                (searchOutput)="searchRows($event)"
                [searchId]="'delete-loan-search'"
                [searchBoxHeight]="44"
                [resetSearch]="false"
            >
            </search-dialog>
        </div>
    </div>
    <div>
        <kendo-grid
            #grid="kendoGrid"
            class="lg-kendo-grid"
            [loading]="loading"
            [data]="gridView"
            [pageSize]="state.take"
            [skip]="state.skip"
            [sort]="state.sort"
            [sortable]="false"
            [pageable]="pageable"
            [scrollable]="'scrollable'"
            (dataStateChange)="dataStateChange($event)"
        >
            <kendo-grid-column
                field="identifier"
                title="LOAN #"
                format="{0:c}"
                [style]="{ cursor: 'pointer' }"
            >
                <ng-template kendoGridCellTemplate let-record>
                    <div>
                        <a (click)="cellClickHandler(record)" class="hyperlink-name">
                            {{ record.identifier }}</a
                        >
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="name" title="BORROWER"> </kendo-grid-column>

            <kendo-grid-column field="description" title="DELETE">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button
                        *ngIf="dataItem?.requestedByEmail === ''"
                        type="button"
                        class="btn-w-100 second-button"
                        mat-stroked-button
                        color="warn"
                        kendoGridRemoveCommand
                        outlined
                        (click)="deleteHandler(dataItem.identifier)"
                    >
                        DELETE
                    </button>
                    <span *ngIf="dataItem?.requestedByEmail !== ''">
                        PENDING - {{ dataItem?.requestedByEmail }}
                    </span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</mat-card>
